import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  products: [], // Array of wholesale product objects
};

const wholesaleCartSlice = createSlice({
  name: 'wholesaleCart',
  initialState,
  reducers: {
    addToWholesaleCart: (state, action) => {
      const items = action.payload; // this will be an array
      items.forEach(product => {
        const existing = state.products.find(p => p.id === product.id && p.size === product.size && p.plating === product.plating);
    
        if (existing) {
          existing.quantity += product.quantity;
        } else {
          state.products.push(product);
        }
      });
    },
    

    removeFromWholesaleCart: (state, action) => {
      const productId = action.payload;
      state.products = state.products.filter(p => p.id !== productId);
    },

    clearWholesaleCart: (state) => {
      state.products = [];
    },

    incrementWholesaleQuantity: (state, action) => {
      const productId = action.payload;
      const product = state.products.find(p => p.id === productId);
      if (product) {
        product.quantity += 1;
      }
    },

    decrementWholesaleQuantity: (state, action) => {
      const productId = action.payload;
      const product = state.products.find(p => p.id === productId);
      if (product && product.quantity > 1) {
        product.quantity -= 1;
      }
    },
  },
});

export const {
  addToWholesaleCart,
  removeFromWholesaleCart,
  clearWholesaleCart,
  incrementWholesaleQuantity,
  decrementWholesaleQuantity,
} = wholesaleCartSlice.actions;

export default wholesaleCartSlice.reducer;
